import { cn } from '@/lib/utils';

export interface StatTileProps {
  label: string;
  value: number;
  variant?: 'default' | 'success' | 'destructive' | 'warning' | 'info' | undefined;
  onClick?: (() => void) | undefined;
  clickable?: boolean | undefined;
}

export function StatTile({ label, value, variant = 'default', onClick, clickable }: StatTileProps) {
  const colorMap: Record<NonNullable<StatTileProps['variant']>, string> = {
    default: 'text-foreground',
    success: 'text-success',
    destructive: 'text-destructive',
    warning: 'text-warning',
    info: 'text-info',
  };
  return (
    <div
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      aria-label={clickable ? `Filter to ${label}` : undefined}
      onClick={onClick}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.();
              }
            }
          : undefined
      }
      className={cn(
        'flex flex-col items-center rounded-md border border-border bg-muted/30 p-3',
        clickable && 'cursor-pointer hover:bg-muted/60 transition-colors',
      )}
    >
      <span className={cn('text-xl font-bold', colorMap[variant])}>{value}</span>
      <span className="text-xs text-muted-foreground">{label}</span>
    </div>
  );
}
